import styled from "styled-components";
import FormComponent from "./FormComponent";
import { Colors } from "../colors/colors";
import Title from "../title/Title";
import SubTitle from "../subtitle/SubTitle";
import { ISubHeaderType, IHeaderType } from "../../types/types";
import { useFormDetails } from "../../hooks/useFormDetails";
import InitiativesFooter from "../../pages/initiatives/components/InitiativesFooter";



const Right = () => {
  const {
    secondaryColor
  } =
    Colors();

  const {
    actionText,
    actionSubText,
    formTitle,
    formSrc
  } = useFormDetails();

  return (
    <>
      <Container>
        <Title
          textColor={secondaryColor}
          text={actionText}
          style={{
            textAlign: "center",
            margin: "0",
          }}
          type={IHeaderType.h2}
        />

        <SubTitle
          textColor={secondaryColor}
          text={actionSubText}
          style={{
            textAlign: "center",
          }}
          type={ISubHeaderType.h2}
        />

        <FormComponent
          formTitle={formTitle}
          formSrc={formSrc}
        />
      </Container>

      <InitiativesFooter />

    </>
  );
};

export default Right;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  background-color: transparent;
`;
